import {FaAngleDown, FaAngleRight} from "react-icons/fa6";

// @ts-expect-error TS7016
import ReactUtils from "@/legacy/ReactUtils";
import {AuditDetails} from "@/pages/pagespeed/report/body/AuditDetails.tsx";
import {AuditScoreBadge} from "@/pages/pagespeed/report/body/AuditScoreBadge.tsx";
import {removeLinksFromMarkdown} from "@/pages/pagespeed/report/body/legacyHelpers.tsx";

interface InnerAudit extends JSON {
  id: string;
  title: string;
  description: string;
  weight: number;
  score: number;
  displayValue?: string;
  impacting?: string[];
}

interface AuditProps {
  audit: InnerAudit;
}

export const Audit = ({audit}: AuditProps) => {
  const key = ReactUtils.Key.get(audit.id);

  let impact = "low";
  if (audit.weight >= 10) {
    impact = "med";
  } else if (audit.weight >= 30) {
    impact = "high";
  } else if (audit.weight == undefined) {
    impact = "n/a";
  }

  return (
    <div key={audit.id} className="audit p-3">
      <div className="audit-header collapsed" data-bs-toggle="collapse" data-bs-target={`#audit-${key}`}>
        <div className="d-none d-sm-inline-block">
          <AuditScoreBadge audit={audit} />
        </div>
        <span className="flex-fill">{audit.title}</span>
        <button className="btn btn-link">
          <FaAngleDown className="fa-angle-down d-print-none" />
          <FaAngleRight className="fa-angle-right d-print-none" />
        </button>
      </div>
      <div className="verbose collapse mt-3" id={`audit-${key}`}>
        <div className="audit-descritpion mb-3">{removeLinksFromMarkdown(audit.description)}</div>
        {audit.score !== null && (
          <div className="audit-score mb-2">
            <div className="d-inline-block d-sm-none me-2">
              <div className="audit-score-badge">{<AuditScoreBadge audit={audit} />}</div>
            </div>
            Score: {audit.score * 100}%
          </div>
        )}
        {audit.displayValue && <div className="audit-display-value mb-3">Result: {audit.displayValue}</div>}
        <AuditDetails audit={audit} />
        {audit.impacting && audit.impacting.length > 0 && (
          <div>
            Impact: <span className={`impact-badge impact-${impact}`}>{impact}</span> affecting:{" "}
            {audit.impacting.join(", ")}
            <br />
          </div>
        )}
      </div>
    </div>
  );
};
